export const routeProps = {
  path: '/login',
  exact: true,
};

export default () => routeProps;
